
const Phones=()=>{
    return(
        <div>
            <p className="text-dark">Phone Categories</p>
        </div>

    )
}
export default Phones